/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

angular.module('prism-ui.components').service('MediaAcceptProfileService',
    function (_, $q, $route, $routeParams, $location, AcceptProfileResourceFactory, RepositoryRootsResourceFactory, PaginationService,
              MediaConversionTemplateService, MacCaptionTemplatesResourceFactory) {

        var self = this;
        self.originalAcceptProfile = {};
        self.mainForm = null;

        var handleGridDataQuery = function (gridData, responseHeaders) {
            PaginationService.parseResponseHeaders(responseHeaders());
            PaginationService.pageData = gridData;
            self.currentPageSize = gridData.length;
        };


        self.createNewProfile = function (acceptProfileType) {
            self.mapObject = {
                type: acceptProfileType
            };
            $location.url('/system/templates/media/acceptProfiles/edit/-1?editView=properties');
        };

        self.getAcceptProfiles = function (queryOpts) {
            return AcceptProfileResourceFactory.query(queryOpts, handleGridDataQuery).$promise;
        };

        self.getAcceptProfile = function (profileId) {
            return AcceptProfileResourceFactory.getAcceptProfile({id: profileId}).$promise;
        };

        self.getValidators = (profileId, includeHidden, criteria = null) => {

            let getValidatorsPromise = AcceptProfileResourceFactory.getValidators({
                profileId: profileId,
                includeHidden: includeHidden
            }).$promise;
            if (criteria === null) {
                return getValidatorsPromise;
            } else {
                return getValidatorsPromise.then((validators) => {
                    return _.filter(validators, criteria);
                });
            }
        };

        self.updateValidators = (profileId, validators) => {
            return AcceptProfileResourceFactory.updateValidators({profileId: profileId}, validators).$promise;
        };

        self.updateValidatorsFromMedia = (profileId, virtualPath) => {
            return AcceptProfileResourceFactory.updateValidatorsFromMedia({profileId: profileId, mediaPath: virtualPath}).$promise;
        };

        self.updateValidatorsFromMediaInfo = (profileId, mediaInfoXml) => {
            return AcceptProfileResourceFactory.updateValidatorsFromMedia({profileId: profileId}, mediaInfoXml).$promise;
        };

        self.toggleValidatorVisibility = (id) => {
            return AcceptProfileResourceFactory.toggleValidatorVisibility({id: id}).$promise;
        };

        self.getMediaAcceptProfileEditViewData = () => {
            var repositoryRootsPromise = RepositoryRootsResourceFactory.query().$promise;
            var macCaptionTemplatesPromise = MacCaptionTemplatesResourceFactory.query().$promise;
            var acceptTemplatesPromise = AcceptProfileResourceFactory.query().$promise;
            var conversionTemplatesPromise = MediaConversionTemplateService.getAllMediaConversionTemplates();
            return $q.all({
                repositoryRoots: repositoryRootsPromise,
                mediaConversionTemplates: conversionTemplatesPromise,
                macCaptionTemplates: macCaptionTemplatesPromise,
                acceptTemplates: acceptTemplatesPromise,
            });
        };

        self.saveAcceptProfile = function (acceptProfile) {
            return AcceptProfileResourceFactory.save(acceptProfile).$promise;
        };

        self.hideAcceptProfile = function (acceptProfileId) {
            return AcceptProfileResourceFactory.hideAcceptProfile({id: acceptProfileId}).$promise;
        };

        self.cloneAcceptProfile = function (acceptProfile) {
            return AcceptProfileResourceFactory.cloneAcceptProfile({id: acceptProfile.id}).$promise;
        };
    });
